import { useControlledState } from '@react-stately/utils';
import { createContext, useContext } from 'react';

export type SearchState = {
    /** Search query. */
    searchQuery: string;

    /** Callback to update the search query. */
    setSearchQuery: (query: string) => void;
};

export type SearchStateProps = {
    /** Search query. */
    searchQuery?: string;
    /** Callback to listen when query changes. */
    onSearchQueryChange?: (query: string) => void;
    /** Default search query. */
    defaultSearchQuery?: string;
};

/**
 * Create a new search state.
 */
export function useSearchState(props: SearchStateProps): SearchState {
    const [searchQuery, setSearchQuery] = useControlledState(
        props.searchQuery,
        props.defaultSearchQuery ?? '',
        props.onSearchQueryChange
    );
    return { searchQuery, setSearchQuery };
}

/**
 * Context for managing search state.
 */
export const SearchContext = createContext<SearchState | null>(null);

/**
 * Get the search query in the current context.
 */
export function useSearchQuery() {
    const ctx = useContext(SearchContext);
    return ctx?.searchQuery ?? null;
}
